module.exports = __webpack_public_path__ + "img/028.9ed22867.png";